// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-carousel-media{--item-gap:16px}@media (min-width:768px){.h-carousel-media{--item-gap:10px}}.h-carousel-media__item{width:100vw;max-width:390px;aspect-ratio:1/1;margin-right:var(--item-gap);background-repeat:no-repeat;background-position:50%;background-size:cover}", ""]);
// Exports
module.exports = exports;
